import CornerCloseBtn from "src/components/buttons/CornerCloseBtn/CornerCloseBtn";

interface ModalHeaderProps {
  title: string | React.ReactNode;
  onClose?: () => void;
}

export default function ModalHeader({ title, onClose }: ModalHeaderProps) {
  return (
    <header className="flex items-center border-b border-grey-900 pl-4 pr-2 py-2">
      <h1 className="text-xl font-normal">{title}</h1>
      {onClose && (
        <CornerCloseBtn
          onClick={onClose}
          className="relative! top-0! right-0! ml-auto"
        />
      )}
    </header>
  );
}
